export default "__VITE_ASSET__D4ZPi$i9__"